import React from "react";
import { Pressable, StyleSheet, ViewStyle } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";

type CheckboxRowProps = {
  label: string;
  checked: boolean;
  onToggle: () => void;
  style?: ViewStyle;
  disabled?: boolean;
};

export function CheckboxRow({ label, checked, onToggle, style, disabled = false }: CheckboxRowProps) {
  const { colors } = useTheme();

  return (
    <Pressable
      style={({ pressed }) => [
        styles.container,
        {
          backgroundColor: pressed ? colors.backgroundSecondary : "transparent",
          opacity: disabled ? 0.5 : 1,
        },
        style,
      ]}
      onPress={onToggle}
      disabled={disabled}
    >
      <MaterialCommunityIcons
        name={checked ? "checkbox-marked" : "checkbox-blank-outline"}
        size={24}
        color={checked ? colors.primary : colors.placeholder}
        style={styles.checkbox}
      />
      <ThemedText style={[styles.label, { color: colors.text }]}>{label}</ThemedText>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "flex-start",
    paddingVertical: 12,
    paddingHorizontal: 4,
    borderRadius: 8,
  },
  checkbox: {
    marginRight: 12,
    marginTop: 2,
  },
  label: {
    fontSize: 15,
    flex: 1,
    lineHeight: 22,
  },
});
